import {Component, Inject, Input} from 'ng-metadata/core';
import {SearchStateService} from "../../searchState.service";
import {StringUtils} from '../../../nddUtils/stringUtils.service';

const unescape = require('lodash/unescape');

@Component({
    "selector": 'prm-no-search-result',
    templateUrl: 'components/search/searchResult/searchResultList/noSearchResult.html',
})

    
    
export class PrmNoSearchResult{
    @Input() private term;

    constructor( private searchStateService: SearchStateService,
                private stringUtils: StringUtils,
                @Inject('$translate') private $translate){
    }

    get isSearchWithFilter() {
        return this.searchStateService.getSearchObject().facets.length > 0;
    }
    
    get description() {
        let descriptionCode = this.isSearchWithFilter ? 'nui.noresultswithfilter.description' : 'nui.noresults.description'; 
        return this.stringUtils.decode(this.$translate.instant(descriptionCode , {term: this.stringUtils.encode(this.term)}));
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/noSearchResult.directive.ts